import { render, staticRenderFns } from "./ViewClinics.vue?vue&type=template&id=90c82976"
import script from "./ViewClinics.vue?vue&type=script&lang=js"
export * from "./ViewClinics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports